import { ProjectDetail } from '@mercator-gcp/types/backend/Project';
import { EmptyField } from 'components/elements/EmptyField';
import { ExternalLink } from 'components/elements/ExternalLink';
import { formatZipCode } from 'utils/format';
import { titleCase } from 'utils/misc';

type TProps = {
  address?: ProjectDetail['address'];
  zipcode?: ProjectDetail['zipcode'];
  state?: ProjectDetail['state'];
  city?: ProjectDetail['city'] | null;
  sx?: Object;
};

const ProjectAddress = ({ address, zipcode, city, state, sx }: TProps) => {
  if (!address) {
    return <EmptyField />;
  }

  const formattedZip = zipcode ? formatZipCode(zipcode) : '';

  const fullAddress = titleCase(`${[address, city, state].join(', ')} ${formattedZip}`);
  const encodedAddress = encodeURIComponent(fullAddress);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <ExternalLink to={mapUrl} sx={sx}>
      {titleCase(fullAddress)}
    </ExternalLink>
  );
};

export default ProjectAddress;
